import PropTypes from 'prop-types'
import React from 'react'

import CrossSellingBar from '../../templateComponents/CrossSellingBar'
import EmptyProductListItem from '../../templateComponents/EmptyProductListItem'
import ProductListItem from '../../templateComponents/ProductListItem'

export default function Crossselling({ product }) {
  return (
    <CrossSellingBar
      product={product}
      breakpoints={['480px', '782px', '992px']}
      renderProductItem={(product, productIndex, trackProductClick) => (
        <ProductListItem product={product} productIndex={productIndex} trackProductClick={trackProductClick} />
      )}
      renderEmptyProductItem={() => <EmptyProductListItem />}
    />
  )
}

Crossselling.propTypes = {
  product: PropTypes.object.isRequired,
}
